export interface EntityTypeModel {
  types: EntityType[];
  subTypes: EntityType[];
}
export interface EntityType {
  id: number;
  name: string;
  code: string;
  hash: string;
  isActive: boolean;
}
export class EntityTypeMap {
  types: Map<number, EntityType> = new Map<number, EntityType>();
  subTypes: Map<number, EntityType> = new Map<number, EntityType>();
}
